import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-ipod",
  "use": "icon-si-glyph-ipod-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-ipod\" id=\"icon-si-glyph-ipod\"><title>791</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(4.000000, 0.000000)\" fill=\"#434343\"><ellipse cx=\"4.469\" cy=\"11.488\" rx=\"1.469\" ry=\"1.488\" class=\"si-glyph-fill\" /><path d=\"M8.30102075,0.021 L0.778979248,0.021 C0.371127314,0.021 0.04,0.326 0.04,0.7 L0.04,15.295 C0.04,15.67 0.370117779,15.974 0.778979248,15.974 L8.30102075,15.974 C8.71089176,15.974 9.04,15.67 9.04,15.295 L9.04,0.7 C9.04,0.326 8.71089176,0.021 8.30102075,0.021 L8.30102075,0.021 Z M4.5,14 C3.11918605,14 2,12.881146 2,11.5 C2,10.1178862 3.11918605,9 4.5,9 C5.87984496,9 7,10.118854 7,11.5 C7,12.881146 5.87984496,14 4.5,14 L4.5,14 Z M8,6 L1,6 L1,1 L8,1 L8,6 L8,6 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-ipod.svg
// module id = d2YY
// module chunks = 62